import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import ProductNew from '../../components/ProductNew';
import type { Category, AdviceResponse } from '../../types/product';

interface ProductsState {
  adviceResponseObject: AdviceResponse;
  allowedProducts: string[];
  category: Category;
}

function Products() {
  const navigate = useNavigate();
  const location = useLocation();
  const { adviceResponseObject, allowedProducts, category } = (location.state?.products ?? {}) as ProductsState;

  const productsToDisplay = category.products.filter((productIndex) => allowedProducts.includes(productIndex));

  return (
    <>
      <section className="site-container">
        <div className="background-header-results">
          <div className="site-container">
            <button className="btn btn-outline-white inline-flex items-center gap-2.5" onClick={() => navigate(-1)}>
              <i className="fas fa-chevron-left"></i>
              <span className="text-lg">Terug naar advies</span>
            </button>
            <h1 className="text-white mt-4 lg:mt-2.5">{category.name ?? 'Producten'}</h1>
            {category?.description && (
              <p className="mt-2 text-white hidden sm:block">{category.description}</p>
            )}
          </div>
        </div>
        <div className="py-4 w-full rounded-lg">
          <div className="site-container">
            {category && (
              <div key={category.id} className="flex flex-col gap-4 p-5 sm:p-10 bg-white mt-4 rounded-[20px]">
                <h4>Producten</h4>
                <div className="grid grid-cols-1 gap-6">
                  {!!productsToDisplay.length &&
                    productsToDisplay.map((productIndex) => {
                      const product = adviceResponseObject.products[productIndex];
                      if (product) return <ProductNew key={uuidv4() + '-' + product.id} product={product} />;
                    })}
                  {!productsToDisplay.length && <p>Geen producten</p>}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Products;
